export const STEP_NAMES = [
  'select-product',
  'select-goal',
  'consent',
  'upload-documents',
  'loan-application-details',
  'applicant-details',
  'employment',
  'income',
  'expenses',
  'assets',
  'liabilities',
  'review',
  'outcome',
] as const

export type StepName = typeof STEP_NAMES[number]

export const stepNameToNumber = (stepName: string | number): number => {
  if (typeof stepName === 'number') {
    return stepName >= 0 && stepName < STEP_NAMES.length ? stepName : 0
  }

  const index = STEP_NAMES.indexOf(stepName as StepName)
  return index !== -1 ? index : 0
}

export const stepNumberToName = (stepNumber: number): StepName => {
  return STEP_NAMES[stepNumber] || STEP_NAMES[0]
}

export const isValidStep = (step: string | number): boolean => {
  if (typeof step === 'number') {
    return step >= 0 && step < STEP_NAMES.length
  }
  return STEP_NAMES.includes(step as StepName)
}
